export default {
    ACTIVE: 'active',
    ENDED: 'ended',
    PENDING: 'pending',
};
